import { useState } from 'react';
import saveBlobAsFile from '../util/saveBlobAsFile';

const downloadResource = async (url: string, filename: string) => {
    return fetch(url, {
        mode: 'cors',
    })
        .then(async response => response.blob())
        .then(blob => saveBlobAsFile(blob, filename))
        .catch(e => {
            throw e;
        });
};

const useAssetDownload = (url: string, filename: string) => {
    const [loading, setLoading] = useState(false);

    return {
        download: async () => {
            try {
                setLoading(true);
                await downloadResource(url, filename);
            } finally {
                setLoading(false);
            }
        },
        setLoading,
        loading,
    };
};
export default useAssetDownload;
